module.exports = __webpack_public_path__ + "static/media/face-7.8b2daeca.jpg";